var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;stroke:#fff;}.b{opacity:0.116;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1438 -1318)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.583.918A2.777,2.777,0,0,0,9.523,0,2.867,2.867,0,0,0,6.7,2.91a2.981,2.981,0,0,0,.073.663A7.931,7.931,0,0,1,.958.531,2.976,2.976,0,0,0,.576,2,2.933,2.933,0,0,0,1.831,4.418,2.759,2.759,0,0,1,.552,4.055v.035A2.89,2.89,0,0,0,2.817,6.944a2.676,2.676,0,0,1-.744.1A2.735,2.735,0,0,1,1.542,7a2.835,2.835,0,0,0,2.636,2.02,5.554,5.554,0,0,1-3.5,1.246A5.624,5.624,0,0,1,0,10.222a7.824,7.824,0,0,0,4.326,1.306,8.11,8.11,0,0,0,8.03-8.28c0-.127,0-.253-.007-.377a5.809,5.809,0,0,0,1.407-1.506,5.5,5.5,0,0,1-1.62.458A2.9,2.9,0,0,0,13.376.213,5.53,5.53,0,0,1,11.583.918Z",
    transform: "translate(1447.82 1328.627)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1438 1318)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 16.5,
    cy: 16.5,
    r: 16.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 16.5,
    cy: 16.5,
    r: 16
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0a3b13cf293445a2dd6a700d21a2ec18.svg";
export { ForwardRef as ReactComponent };